import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MCSonic from '../animations/mc-sonic.min.js';

export default function MastercardAnimation({onCompleteAnimation}){
  const dispatch = useDispatch();
  const sonic = useRef(null);
  const onComplete = () => {
    onCompleteAnimation();
  };
  useEffect(() => {
    const tout = setTimeout(onComplete, 10000);
    const tdelay = setTimeout(() => {sonic.current.play();}, 500);
    document.addEventListener('sonicCompletion', onComplete);
    
    return () => {
      console.log({"clearing MC Sonic":tout});
      document.removeEventListener('sonicCompletion', onComplete);
      clearTimeout(tout);
      clearTimeout(tdelay);
    };
  }, []);
  return (
    <div className={"loading-detail loading-video"}>
      <div className={"modal-title"}>
        <mc-sonic sonicBackground="white" ref={sonic}></mc-sonic>
      </div>
    </div>
  );
}